module.exports = __webpack_public_path__ + "static/media/pridefit_04.0ef55f90.jpg";